import React, { useState, useRef } from "react";
import domtoimage from "dom-to-image";
import styles from "./PlacaDiseno1.module.css";
import nuevoLogo from "../../../Assets/nuevoLogo.png";

const PlacaDiseno1 = () => {
  const [images, setImages] = useState({
    mainImage: null,
    secondaryImage1: null,
    secondaryImage2: null,
  });
  const [titleBadge, setTitleBadge] = useState("Terreno en\nVENTA");
  const [location, setLocation] = useState("Zona Valle de Uco\nTunuyán");
  const [price, setPrice] = useState("USD 35.000");
  const [description, setDescription] = useState(
    "Country Rural Sauce Viejo - Colonia Las Rosas\n5000m2 - Financiación hasta 12 cuotas"
  );
  const [agent, setAgent] = useState("JULIETA GARCÍA CCPIM 2009");

  const placaRef = useRef(null);

  const handleImageChange = (e, imageType) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        setImages((prev) => ({ ...prev, [imageType]: event.target.result }));
      };
      reader.readAsDataURL(file);
    }
  };

  const downloadPlaca = () => {
    const element = placaRef.current;
    const originalStyle = element.getAttribute("style");

    element.setAttribute(
      "style",
      `width: 1080px; height: 1080px; transform: none; transform-origin: top left; position: relative;`
    );

    domtoimage
      .toPng(element)
      .then((dataUrl) => {
        const link = document.createElement("a");
        link.download = "placa_diseno1.png";
        link.href = dataUrl;
        link.click();
      })
      .catch((error) => {
        console.error("Error al generar la imagen:", error);
      })
      .finally(() => {
        if (originalStyle) {
          element.setAttribute("style", originalStyle);
        } else {
          element.removeAttribute("style");
        }
      });
  };

  return (
    <div className={styles.container}>
      <div className={styles.editControls}>
        <label>
          Título Badge:
          <textarea
            value={titleBadge}
            onChange={(e) => setTitleBadge(e.target.value)}
            className={styles.input}
            rows={2}
          />
        </label>
        <label>
          Ubicación:
          <textarea
            value={location}
            onChange={(e) => setLocation(e.target.value)}
            className={styles.input}
            rows={2}
          />
        </label>
        <label>
          Precio:
          <input
            type="text"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
            className={styles.input}
          />
        </label>
        <label>
          Descripción:
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            className={styles.input}
            rows={3}
          />
        </label>
        <label>
          Agente:
          <input
            type="text"
            value={agent}
            onChange={(e) => setAgent(e.target.value)}
            className={styles.input}
          />
        </label>
      </div>

      <div ref={placaRef} className={styles.placa}>
        {/* Background main image */}
        <div className={styles.backgroundImage}>
          {images.mainImage ? (
            <img src={images.mainImage} alt="Fondo" />
          ) : (
            <div
              className={styles.placeholder}
              onClick={() =>
                document.getElementById("fileInputMainD1").click()
              }
            >
              Click para cargar imagen de fondo
            </div>
          )}
          {images.mainImage && (
            <div
              className={styles.changeOverlay}
              onClick={() =>
                document.getElementById("fileInputMainD1").click()
              }
            />
          )}
          <input
            type="file"
            id="fileInputMainD1"
            accept="image/*"
            onChange={(e) => handleImageChange(e, "mainImage")}
            hidden
          />
        </div>

        {/* Gradient overlay */}
        <div className={styles.gradientOverlay} />

        {/* Title badge top-left */}
        <div className={styles.titleBadge}>
          {titleBadge.split("\n").map((line, i) => (
            <span key={i}>
              {line}
              {i < titleBadge.split("\n").length - 1 && <br />}
            </span>
          ))}
        </div>

        {/* Location top-right */}
        <div className={styles.locationText}>
          {location.split("\n").map((line, i) => (
            <span key={i}>
              {line}
              {i < location.split("\n").length - 1 && <br />}
            </span>
          ))}
        </div>

        {/* Price badge center */}
        <div className={styles.priceBadge}>
          <span className={styles.pricePrefix}>
            {price.split(" ")[0]}
          </span>{" "}
          <span className={styles.priceAmount}>
            {price.split(" ").slice(1).join(" ")}
          </span>
        </div>

        {/* Description */}
        <div className={styles.descriptionText}>
          {description.split("\n").map((line, i) => (
            <span key={i}>
              {line}
              {i < description.split("\n").length - 1 && <br />}
            </span>
          ))}
        </div>

        {/* Secondary images bottom-left */}
        <div className={styles.secondaryImages}>
          <div
            className={styles.secondaryImage}
            onClick={() =>
              document.getElementById("fileInputSec1D1").click()
            }
          >
            {images.secondaryImage1 ? (
              <img src={images.secondaryImage1} alt="Secundaria 1" />
            ) : (
              <p>Imagen 1</p>
            )}
            <input
              type="file"
              id="fileInputSec1D1"
              accept="image/*"
              onChange={(e) => handleImageChange(e, "secondaryImage1")}
              hidden
            />
          </div>

          <div
            className={styles.secondaryImage}
            onClick={() =>
              document.getElementById("fileInputSec2D1").click()
            }
          >
            {images.secondaryImage2 ? (
              <img src={images.secondaryImage2} alt="Secundaria 2" />
            ) : (
              <p>Imagen 2</p>
            )}
            <input
              type="file"
              id="fileInputSec2D1"
              accept="image/*"
              onChange={(e) => handleImageChange(e, "secondaryImage2")}
              hidden
            />
          </div>
        </div>

        {/* Agent text bottom-left */}
        <div className={styles.agentText}>{agent}</div>

        {/* Logo bottom-right */}
        <div className={styles.logo}>
          <img src={nuevoLogo} alt="Logo By Raíces" />
        </div>
      </div>

      <button onClick={downloadPlaca} className={styles.downloadButton}>
        Descargar Placa
      </button>
    </div>
  );
};

export default PlacaDiseno1;
